import { Link, useRouterState } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export const Navigation = (): React.ReactNode => {
  const { i18n, t } = useTranslation('common');
  const { location } = useRouterState();

  const linkClass = (path: string): string =>
    `text-sm font-medium transition-colors duration-200 hover:underline min-[480px]:text-base ${location.pathname === path ? 'underline' : ''}`;

  // Hide navigation on Careers, Privacy, Support, and La Colaborativa pages
  if (
    location.pathname === '/careers' ||
    location.pathname === '/la-colaborativa' ||
    location.pathname === '/privacy' ||
    location.pathname === '/support'
  ) {
    return null;
  }

  return (
    <>
      {/* Custom breakpoint at 900px: top bar with solid background; links centered */}
      <style>{`
        @media (min-width: 900px) {
          nav[data-public-web-nav] {
            top: 0 !important;
            bottom: auto !important;
            border-top: none !important;
            border-bottom: 1px solid rgb(229 231 235);
            background-color: rgb(255 255 255) !important;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06) !important;
          }
          nav[data-public-web-nav] > [data-public-web-nav-inner] {
            margin-inline: auto;
            max-width: 56rem;
            width: 100%;
            justify-content: center;
            padding-inline: 1.5rem;
          }
        }
      `}</style>
      <nav
        data-public-web-nav
        className="pointer-events-auto absolute inset-x-0 bottom-0 z-30 flex justify-center border-t border-gray-200 bg-white p-4 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]"
      >
        <div
          data-public-web-nav-inner
          className="mx-auto flex w-full max-w-4xl justify-center gap-3 px-1 min-[480px]:gap-5 min-[480px]:px-2 sm:gap-7 md:gap-8 md:px-0"
        >
          <Link to="/" className={`${linkClass('/')} cursor-pointer`} style={{ color: '#1F4D67' }}>
            {t('nav.home')}
          </Link>
          <Link to="/about" className={`${linkClass('/about')} cursor-pointer`} style={{ color: '#1F4D67' }}>
            {t('nav.about')}
          </Link>
          <Link to="/careers" className={`${linkClass('/careers')} cursor-pointer`} style={{ color: '#1F4D67' }}>
            {t('nav.careers')}
          </Link>
          <button
            type="button"
            className={`${linkClass('/login')} cursor-pointer border-0 bg-transparent p-0 font-[inherit]`}
            style={{ color: '#1F4D67' }}
            onClick={() => {
              const resolved = (i18n.resolvedLanguage ?? i18n.language).toLowerCase();
              const uiLocales = resolved.startsWith('es') ? 'es' : 'en';
              const patientWebUrl = import.meta.env.VITE_PATIENT_WEB_URL ?? 'http://localhost:4002';
              const loginUrl = new URL(`${patientWebUrl}/today`);
              loginUrl.searchParams.set('ui_locales', uiLocales);
              window.location.assign(loginUrl.toString());
            }}
          >
            {t('nav.login')}
          </button>
        </div>
      </nav>
    </>
  );
};
